import { onBeforeUnmount, ref } from 'vue';
import { useApplicationStore } from '@/store/applicationStore';

export function useServiceWorkerEvents() {
  const refreshing = ref(false);
  const updateExists = ref(false);
  const registration = ref<ServiceWorkerRegistration | null>(null);

  function refreshApp() {
    const waiting = registration.value?.waiting;
    if (!waiting || refreshing.value) return;
    if (useApplicationStore().unsavedPages.some((page: any) => page.unSaved)) {
      window.messageBus?.$emit('showMessage', {
        type: 'warning',
        text: 'Save or discard your changes before updating.',
      });
      return;
    }
    waiting.postMessage({ type: 'SKIP_WAITING' });
    updateExists.value = false;
  }

  const state = { refreshing, updateExists, registration, refreshApp };
  if (!('serviceWorker' in navigator)) return state;

  const serviceWorker = navigator.serviceWorker;
  let hadController = Boolean(serviceWorker.controller);

  function updateAvailable(event: Event) {
    const nextRegistration = (event as CustomEvent).detail.registration as ServiceWorkerRegistration;
    registration.value = nextRegistration;
    updateExists.value = Boolean(nextRegistration.waiting);
  }

  function controllerChanged() {
    // First installation can take control without replacing the running app.
    if (!hadController) {
      hadController = Boolean(serviceWorker.controller);
      return;
    }
    if (!serviceWorker.controller || refreshing.value) return;
    refreshing.value = true;
    window.location.reload();
  }

  document.addEventListener('swUpdated', updateAvailable);
  serviceWorker.addEventListener('controllerchange', controllerChanged);
  onBeforeUnmount(() => {
    document.removeEventListener('swUpdated', updateAvailable);
    serviceWorker.removeEventListener('controllerchange', controllerChanged);
  });

  return state;
}
